export default function preparationListeMouvementClient(piece, mouvementsClients,
  mouvementClientReglement) {
  if (mouvementsClients === null || mouvementClientReglement === null) return;

  mouvementsClients.forEach((mc) => {
    mc.montantTtc = mc.debit - mc.credit;
    mc.inputAffecte = 0.0;
    mc.inputAffectePopup = 0.0;
    mc.escompteAffecte = 0.0;

    mc.lettrages.forEach(lettrage => {
      if (lettrage.mouvementClient1Id === mouvementClientReglement.id) {
        mc.inputAffecte += lettrage.montant;
      }
      if (lettrage.mouvementClient2Id === mouvementClientReglement.id) {
        mc.inputAffecte += lettrage.montant;
      }
      if (mouvementClientReglement.mouvementClientEnfants !== undefined
        && mouvementClientReglement.mouvementClientEnfants !== null) {
        mouvementClientReglement.mouvementClientEnfants.forEach(mcEscompte => {
          if (lettrage.mouvementClient1Id === mcEscompte.id) {
            mc.escompteAffecte += lettrage.montant;
          }
          if (lettrage.mouvementClient2Id === mcEscompte.id) {
            mc.escompteAffecte += lettrage.montant;
          }
        });
      }
    });

    mc.restantAAffecterInitial = mc.resteALettrer + mc.inputAffecte + mc.escompteAffecte;
    mc.solde = mc.resteALettrer;

    piece.restantALettrerTtc += mc.resteALettrer + mc.inputAffecte + mc.escompteAffecte;
    piece.inputAffecte += mc.inputAffecte;
    mouvementsClients.forEach((mc) => {
      mc.inputAffecte += mc.escompteAffecte;
      mc.escompteAffecte = 0.0;
    });
  });

  mouvementsClients.sort((a, b) => {
    const dateA = new Date(a.dateMouvement);
    const dateB = new Date(b.dateMouvement);
    return dateA - dateB;
  });
}
